module.exports = __webpack_public_path__ + "static/media/bhst.76df0816.png";